module.exports = __webpack_public_path__ + "img/about1.31f4a60b.webp";